import { useNavigate } from "react-router-dom";
import "../../assets/css/product.scss";
import DonationStep1Component from "../../components/donation/step1_component";
import { useEffect } from "react";
import { SessionStorageUtil } from "../../utils/session_storage_util";

function DonationStep1Page() {
  const navigate = useNavigate();

  useEffect(() => {
    if (SessionStorageUtil.getItem("accessToken")) {
      navigate("/donation_step2", { replace: true });
    }
  }, [navigate]);

  if (SessionStorageUtil.getItem("accessToken")) {
    return null;
  }

  return <DonationStep1Component />;
}

export default DonationStep1Page;
